export const UPDATE_SELECTED_MENU_ITEM = 'UPDATE_SELECTED_MENU_ITEM'
export const GET_DUMMY_DATA = 'GET_DUMMY_DATA'
export const DATA_REQUESTED = 'DATA_REQUESTED'
export const DATA_LOADED = 'DATA_LOADED'
export const API_ERRORED = 'API_ERRORED'
export const UPDATE_LOADING = 'UPDATE_LOADING'
export const UPDATE_GAME  = 'UPDATE_GAME'
